import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type LogoutIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function LogoutIcon({
  className,
  pathClassName = "stroke-black",
  ...props
}: LogoutIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M15.236 12H3.21"
        className={pathClassName}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <Path
        d="M10.992 16.625l3.966-3.966a.937.937 0 000-1.318l-3.966-3.966"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.852 21.25h4.625a2.312 2.312 0 002.312-2.313V5.063a2.313 2.313 0 00-2.312-2.313h-4.625"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default LogoutIcon;
